var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content tdi-page" },
    [
      _c(
        "div",
        { staticClass: "row-data tdi-toolbar-card" },
        [
          _c("div", { staticClass: "tdi-card-head" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "tdi-card-head-actions" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "tdi-reset-btn",
                    attrs: {
                      plain: "",
                      icon: "el-icon-refresh-left",
                      size: "small",
                    },
                    on: { click: _vm.handleResetFilters },
                  },
                  [_vm._v("\n            Làm mới bộ lọc\n          ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "tdi-form-grid",
              class: { "tdi-form-grid--package": _vm.isPackageMode },
              attrs: {
                model: _vm.searchRequest,
                rules: _vm.searchRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "tdi-form-item",
                  attrs: { label: "Phạm vi", prop: "targetType" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "sk-segmented-control",
                      on: { change: _vm.handleTargetTypeChange },
                      model: {
                        value: _vm.searchRequest.targetType,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchRequest, "targetType", $$v)
                        },
                        expression: "searchRequest.targetType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "CLASS" } }, [
                        _vm._v("Theo lớp"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "GROUP" } }, [
                        _vm._v("Theo nhóm"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "PACKAGE" } }, [
                        _vm._v("Theo gói"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.isPackageMode
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      class: {
                        "is-filter-active": _vm.isFilterActive("monthAndYear"),
                      },
                      attrs: { label: "Tháng", prop: "monthAndYear" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "135px" },
                        attrs: {
                          type: "month",
                          "value-format": "M-yyyy",
                          format: "MM-yyyy",
                          placeholder: "Chọn tháng",
                          clearable: false,
                        },
                        on: { change: _vm.handleMonthChange },
                        model: {
                          value: _vm.searchRequest.monthAndYear,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchRequest, "monthAndYear", $$v)
                          },
                          expression: "searchRequest.monthAndYear",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isPackageMode
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Từ tháng", prop: "fromMonthAndYear" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "135px" },
                        attrs: {
                          type: "month",
                          "value-format": "M-yyyy",
                          format: "MM-yyyy",
                          placeholder: "Từ tháng",
                          clearable: false,
                        },
                        on: { change: _vm.handlePackageDateChange },
                        model: {
                          value: _vm.searchRequest.fromMonthAndYear,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchRequest, "fromMonthAndYear", $$v)
                          },
                          expression: "searchRequest.fromMonthAndYear",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isPackageMode
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Đến tháng", prop: "toMonthAndYear" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "135px" },
                        attrs: {
                          type: "month",
                          "value-format": "M-yyyy",
                          format: "MM-yyyy",
                          placeholder: "Đến tháng",
                          clearable: false,
                        },
                        on: { change: _vm.handlePackageDateChange },
                        model: {
                          value: _vm.searchRequest.toMonthAndYear,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchRequest, "toMonthAndYear", $$v)
                          },
                          expression: "searchRequest.toMonthAndYear",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "tdi-form-item",
                  class: {
                    "is-filter-active": _vm.isFilterActive("kidStatus"),
                  },
                  attrs: { label: "Trạng thái học sinh" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "Chọn trạng thái" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchRequest.kidStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchRequest, "kidStatus", $$v)
                        },
                        expression: "searchRequest.kidStatus",
                      },
                    },
                    _vm._l(_vm.kidStatusList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: {
                          value: item.key,
                          label: item.label || item.value,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.isClassMode || _vm.isPackageMode
                ? _c(
                    "el-form-item",
                    { staticClass: "tdi-form-item", attrs: { label: "Khối" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: {
                            placeholder: _vm.isPackageMode
                              ? "Tất cả"
                              : "Chọn khối",
                            clearable: _vm.isPackageMode,
                          },
                          on: { change: _vm.handleGradeChange },
                          model: {
                            value: _vm.searchRequest.idGrade,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchRequest, "idGrade", $$v)
                            },
                            expression: "searchRequest.idGrade",
                          },
                        },
                        [
                          _vm.isPackageMode
                            ? _c("el-option", {
                                attrs: { label: "Tất cả", value: "" },
                              })
                            : _vm._e(),
                          _vm._l(_vm.gradeOfSchoolList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { value: item.id, label: item.gradeName },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isClassMode || _vm.isPackageMode
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Lớp", prop: "idClass" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "175px" },
                          attrs: {
                            placeholder: _vm.isPackageMode
                              ? "Tất cả"
                              : "Chọn lớp",
                            clearable: _vm.isPackageMode,
                          },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchRequest.idClass,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchRequest, "idClass", $$v)
                            },
                            expression: "searchRequest.idClass",
                          },
                        },
                        [
                          _vm.isPackageMode
                            ? _c("el-option", {
                                attrs: { label: "Tất cả", value: "" },
                              })
                            : _vm._e(),
                          _vm._l(_vm.classList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { value: item.id, label: item.className },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isGroupMode
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Nhóm", prop: "idGroup" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { placeholder: "Chọn nhóm" },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchRequest.idGroup,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchRequest, "idGroup", $$v)
                            },
                            expression: "searchRequest.idGroup",
                          },
                        },
                        _vm._l(_vm.kidGroupList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.nameGroup },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isPackageMode
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Gói dịch vụ", prop: "idPackage" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { placeholder: "Chọn gói" },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchRequest.idPackage,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchRequest, "idPackage", $$v)
                            },
                            expression: "searchRequest.idPackage",
                          },
                        },
                        _vm._l(_vm.packageList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "tdi-form-item",
                  class: { "is-filter-active": _vm.isFilterActive("status") },
                  attrs: { label: "Trạng thái phiếu thu" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { clearable: "", placeholder: "Tất cả" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchRequest.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchRequest, "status", $$v)
                        },
                        expression: "searchRequest.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "tdi-form-item",
                  class: { "is-filter-active": _vm.isFilterActive("name") },
                  attrs: { label: "Tìm theo tên học sinh" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      "prefix-icon": "el-icon-search",
                      placeholder: "Nhập tên học sinh",
                    },
                    on: { clear: _vm.handleSearch },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchRequest.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchRequest, "name", $$v)
                      },
                      expression: "searchRequest.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "tdi-form-item",
                  class: { "is-filter-active": _vm.isFilterActive("turn") },
                  attrs: { label: "Đợt thu" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "110px" },
                      attrs: { placeholder: "Tất cả" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchRequest.turn,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchRequest, "turn", $$v)
                        },
                        expression: "searchRequest.turn",
                      },
                    },
                    _vm._l(_vm.collectionTurns, function (turn) {
                      return _c("el-option", {
                        key: turn,
                        attrs: { value: turn, label: `Đợt ${turn}` },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "row-data tdi-table-card" }, [
        _c("div", { staticClass: "tdi-card-head" }, [
          _c("div", [
            _c("p", { staticClass: "tdi-card-title" }, [
              _vm._v("Danh sách phiếu thu"),
            ]),
            _c("p", { staticClass: "tdi-card-subtitle" }, [
              _vm._v(
                "Hiển thị " +
                  _vm._s(_vm.tableData.length) +
                  " / " +
                  _vm._s(_vm.totalRecord) +
                  " bản ghi."
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                gap: "15px",
                "align-items": "center",
              },
            },
            [
              _vm.multipleSelection.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "tdi-selection-count" }, [
                      _vm._v("\n              Đã chọn: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.multipleSelection.length)),
                      ]),
                      _vm._v(" / "),
                      _c("strong", [_vm._v(_vm._s(_vm.tableData.length))]),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-end",
                    width: "220",
                    trigger: "click",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ipd-settings-menu",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "max-height": "400px",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.nickName,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "nickName", $$v)
                            },
                            expression: "visibleColumns.nickName",
                          },
                        },
                        [_vm._v("Biệt danh")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.className,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "className", $$v)
                            },
                            expression: "visibleColumns.className",
                          },
                        },
                        [_vm._v("Tên lớp")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.hideReceipt,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "hideReceipt", $$v)
                            },
                            expression: "visibleColumns.hideReceipt",
                          },
                        },
                        [_vm._v("Hiển thị")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.parentUnread,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "parentUnread", $$v)
                            },
                            expression: "visibleColumns.parentUnread",
                          },
                        },
                        [_vm._v("PH đã xem")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.invoiceCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "invoiceCode", $$v)
                            },
                            expression: "visibleColumns.invoiceCode",
                          },
                        },
                        [_vm._v("Mã phiếu thu")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.additionalInfo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.visibleColumns,
                                "additionalInfo",
                                $$v
                              )
                            },
                            expression: "visibleColumns.additionalInfo",
                          },
                        },
                        [_vm._v("Thông tin bổ sung")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.unpaidInvoices,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.visibleColumns,
                                "unpaidInvoices",
                                $$v
                              )
                            },
                            expression: "visibleColumns.unpaidInvoices",
                          },
                        },
                        [_vm._v("Phiếu chưa thanh toán")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.releasedInvoices,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.visibleColumns,
                                "releasedInvoices",
                                $$v
                              )
                            },
                            expression: "visibleColumns.releasedInvoices",
                          },
                        },
                        [_vm._v("Phiếu đã phát hành")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.onlinePaymentStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.visibleColumns,
                                "onlinePaymentStatus",
                                $$v
                              )
                            },
                            expression: "visibleColumns.onlinePaymentStatus",
                          },
                        },
                        [_vm._v("Trạng thái TT thanh toán")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "status", $$v)
                            },
                            expression: "visibleColumns.status",
                          },
                        },
                        [_vm._v("Trạng thái")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.turn,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "turn", $$v)
                            },
                            expression: "visibleColumns.turn",
                          },
                        },
                        [_vm._v("Đợt")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.monthYear,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "monthYear", $$v)
                            },
                            expression: "visibleColumns.monthYear",
                          },
                        },
                        [_vm._v("Tháng-Năm")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.beforeMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "beforeMoney", $$v)
                            },
                            expression: "visibleColumns.beforeMoney",
                          },
                        },
                        [_vm._v("Thiếu/Thừa phiếu thu trước")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.sumMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "sumMoney", $$v)
                            },
                            expression: "visibleColumns.sumMoney",
                          },
                        },
                        [_vm._v("Phải thu")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.collectedMoney,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.visibleColumns,
                                "collectedMoney",
                                $$v
                              )
                            },
                            expression: "visibleColumns.collectedMoney",
                          },
                        },
                        [_vm._v("Đã thu")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.cashMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "cashMoney", $$v)
                            },
                            expression: "visibleColumns.cashMoney",
                          },
                        },
                        [_vm._v("Tiền mặt")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.transferMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "transferMoney", $$v)
                            },
                            expression: "visibleColumns.transferMoney",
                          },
                        },
                        [_vm._v("Chuyển khoản")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.afterMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "afterMoney", $$v)
                            },
                            expression: "visibleColumns.afterMoney",
                          },
                        },
                        [_vm._v("Thiếu/Thừa còn lại")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.visibleColumns.feeColumns,
                            callback: function ($$v) {
                              _vm.$set(_vm.visibleColumns, "feeColumns", $$v)
                            },
                            expression: "visibleColumns.feeColumns",
                          },
                        },
                        [_vm._v("Các khoản thu")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "reference",
                        type: "primary",
                        plain: "",
                        icon: "el-icon-setting",
                        size: "small",
                      },
                      slot: "reference",
                    },
                    [_vm._v("Thiết lập cột")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "tdi-table-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
                ref: "invoiceTableRef",
                staticClass: "sk-table tdi-main-table",
                class: { "tdi-table--package": _vm.isPackageMode },
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  "empty-text": _vm.emptyText,
                  "max-height": _vm.$tableMaxHeight,
                  "element-loading-text": _vm.$tableLoading,
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(255,255,255,0)",
                  "summary-method": _vm.getSummaries,
                  "show-summary": "",
                  "row-key": "id",
                },
                on: {
                  "selection-change": _vm.handleSelectionChange,
                  "header-click": _vm.handleTableHeaderClick,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "52", align: "center" },
                }),
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "STT",
                    width: "50",
                    align: "center",
                    fixed: "left",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Họ tên",
                    prop: "fullName",
                    width: "250",
                    fixed: "left",
                    align: "left",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: `Mã HS: ${row.studentCode}`,
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "tdi-student-name-cell" },
                                [_vm._v(_vm._s(row.fullName))]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.visibleColumns.nickName
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Biệt danh",
                        prop: "nickName",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.nickName || "—")),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2352929144
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.className
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Tên lớp",
                        prop: "className",
                        width: "170",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.className || "—")),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        170596345
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.hideReceipt
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Hiển thị",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("el-checkbox", {
                                  attrs: {
                                    disabled: row.status === "UNBILLED",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleHideReceiptChange(row)
                                    },
                                  },
                                  model: {
                                    value: row.hideReceipt,
                                    callback: function ($$v) {
                                      _vm.$set(row, "hideReceipt", $$v)
                                    },
                                    expression: "row.hideReceipt",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2595059717
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.parentUnread
                  ? _c("el-table-column", {
                      attrs: {
                        label: "PH đã xem",
                        width: "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: row.parentUnread
                                        ? "success"
                                        : "info",
                                      size: "mini",
                                      effect: "light",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          row.parentUnread
                                            ? "Đã xem"
                                            : "Chưa xem"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2693601125
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.invoiceCode
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Mã phiếu thu",
                        prop: "invoiceCode",
                        width: "190",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.invoiceCode
                                  ? _c("span", [
                                      _vm._v(_vm._s(row.invoiceCode)),
                                    ])
                                  : _c(
                                      "span",
                                      { staticClass: "tdi-text-muted" },
                                      [_vm._v("—")]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        896487404
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.additionalInfo
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Thông tin bổ sung",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Xem thông tin bổ sung",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "tdi-additional-info-btn",
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-notebook-2",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleOpenAdditionalInfo(
                                            row
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        758810218
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.unpaidInvoices
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Phiếu thu chưa thanh toán",
                        prop: "quantityStock",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.quantityStock > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "tdi-unpaid-badge",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOpenUnpaidDialog(
                                              row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(row.quantityStock) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "tdi-unpaid-badge" },
                                      [_vm._v("0")]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1141771505
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.releasedInvoices
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Phiếu thu đã phát hành",
                        prop: "quantityStock",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.totalInvoiceCount > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "tdi-unpaid-badge",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOpenHistoryDialog(
                                              row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(row.totalInvoiceCount) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "tdi-unpaid-badge" },
                                      [_vm._v("0")]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3404607572
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.onlinePaymentStatus
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Trạng thái TT thanh toán",
                        align: "center",
                        width: "180",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.onlinePaymentStatus
                                  ? _c("i", {
                                      staticClass: "el-icon-check",
                                      staticStyle: {
                                        color: "#22c55e",
                                        "font-weight": "bold",
                                        "font-size": "16px",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass: "el-icon-close",
                                      staticStyle: {
                                        color: "#ef4444",
                                        "font-weight": "bold",
                                        "font-size": "16px",
                                      },
                                    }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        797001834
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.status
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Trạng thái",
                        align: "center",
                        width: "140",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.statusTagType(row.status),
                                      size: "mini",
                                      effect: "light",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.statusLabel(row.status)) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1905918093
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.turn
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Đợt",
                        prop: "turn",
                        width: "60",
                        align: "center",
                      },
                    })
                  : _vm._e(),
                _vm.visibleColumns.monthYear
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Tháng-Năm",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.month) +
                                    "/" +
                                    _vm._s(row.year) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4283044710
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.beforeMoney
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Thiếu/Thừa phiếu thu trước",
                        prop: "beforeMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.beforeMoney > 0
                                        ? "tdi-money--positive"
                                        : "tdi-money--negative",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            row.beforeMoney
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        690760640
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.sumMoney
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Phải thu",
                        prop: "sumMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "tdi-money tdi-money--bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatCurrency")(row.sumMoney)
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2885206753
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.collectedMoney
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Đã thu",
                        prop: "collectedMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "tdi-fee-amount",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEditCollectedMoney(row)
                                      },
                                    },
                                  },
                                  [
                                    row.collectedMoney
                                      ? _c(
                                          "span",
                                          { staticClass: "tdi-money" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatCurrency")(
                                                  row.collectedMoney
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tdi-money tdi-text-muted",
                                          },
                                          [_vm._v("-")]
                                        ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1259342145
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.cashMoney
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Tiền mặt",
                        prop: "cashMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "tdi-money" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(row.cashMoney)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        945868466
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.transferMoney
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Chuyển khoản",
                        prop: "transferMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "tdi-money" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(
                                        row.transferMoney
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        893443520
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.afterMoney
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Thiếu/Thừa còn lại",
                        prop: "afterMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.afterMoney > 0
                                        ? "tdi-money--positive"
                                        : "tdi-money--negative",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            row.afterMoney
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4026008224
                      ),
                    })
                  : _vm._e(),
                _vm.visibleColumns.feeColumns
                  ? _vm._l(_vm.feeColumns, function (item) {
                      return _c("el-table-column", {
                        key: item.prop,
                        attrs: {
                          align: "right",
                          width: "140",
                          label: item.label,
                          prop: item.prop,
                          "class-name": "tdi-fee-column",
                          "label-class-name": _vm.canManageFeeColumns
                            ? "tdi-fee-header is-clickable-header"
                            : "tdi-fee-header is-not-clickable",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: scope.column.label,
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tdi-fee-header-text",
                                          class: {
                                            "is-clickable":
                                              _vm.canManageFeeColumns,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.canManageFeeColumns &&
                                                _vm.handleFeeHeaderClick(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(scope.column.label) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "tdi-fee-amount",
                                      attrs: {
                                        disabled:
                                          _vm.checkPermission([
                                            "tuition_payment_v4",
                                          ]) === false,
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEditRevenueDetail(
                                            row,
                                            item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.hasFeeAmount(row[item.prop])
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tdi-money tdi-money--fee",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("formatCurrency")(
                                                      row[item.prop]
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tdi-money tdi-money--fee",
                                            },
                                            [_vm._v("-")]
                                          ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    label: "Tác vụ",
                    width: "160",
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "tdi-action-buttons" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Thanh toán",
                                    placement: "top",
                                    enterable: false,
                                  },
                                },
                                [
                                  _vm.checkPermission(["tuition_payment_v4"])
                                    ? _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          icon: "el-icon-wallet",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePayment(row)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Lịch sử thao tác",
                                    placement: "top",
                                    enterable: false,
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      size: "mini",
                                      type: "warning",
                                      icon: "el-icon-time",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleActionHistory(row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Lịch sử thanh toán",
                                    placement: "top",
                                    enterable: false,
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      size: "mini",
                                      type: "success",
                                      icon: "el-icon-tickets",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePaymentHistory(row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "tdi-action-row",
            staticStyle: {
              "margin-top": "16px",
              "justify-content": "flex-end",
            },
          },
          [
            _vm.checkPermission(["tuition_fees_services_action_v4"])
              ? _c(
                  "el-dropdown",
                  {
                    attrs: { trigger: "click", placement: "top-end" },
                    on: { command: _vm.handleBatchCommand },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "tdi-batch-action-btn",
                        attrs: { type: "primary" },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-s-operation",
                          staticStyle: { "margin-right": "6px" },
                        }),
                        _vm._v("\n            Tác vụ hàng loạt\n            "),
                        _c("i", {
                          staticClass: "el-icon-arrow-up",
                          staticStyle: {
                            "margin-left": "6px",
                            "font-size": "11px",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "el-dropdown-menu",
                      {
                        staticClass: "tdi-batch-dropdown",
                        attrs: { slot: "dropdown" },
                        slot: "dropdown",
                      },
                      [
                        _c(
                          "el-dropdown",
                          {
                            staticStyle: { display: "block" },
                            attrs: {
                              placement: "left-start",
                              "popper-options": {
                                modifiers: { flip: { enabled: false } },
                              },
                            },
                            on: { command: _vm.handleBatchCommand },
                          },
                          [
                            _c(
                              "el-dropdown-item",
                              { staticClass: "tdi-nested-menu-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tdi-nested-menu-label" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-printer",
                                      staticStyle: { "margin-right": "6px" },
                                    }),
                                    _vm._v("In phiếu thu"),
                                  ]
                                ),
                                _c("i", { staticClass: "el-icon-arrow-left" }),
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              {
                                staticClass: "tdi-batch-dropdown",
                                attrs: { slot: "dropdown" },
                                slot: "dropdown",
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "print_1",
                                      icon: "el-icon-printer",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  In phiếu thu 1 liên\n                "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "print_2",
                                      icon: "el-icon-printer",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  In phiếu thu 2 liên\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.checkPermission(["tuition_excel_export_v4"])
                          ? _c(
                              "el-dropdown",
                              {
                                staticStyle: { display: "block" },
                                attrs: {
                                  placement: "left-start",
                                  "popper-options": {
                                    modifiers: { flip: { enabled: false } },
                                  },
                                },
                                on: { command: _vm.handleBatchCommand },
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { staticClass: "tdi-nested-menu-item" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tdi-nested-menu-label" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-download",
                                          staticStyle: {
                                            "margin-right": "6px",
                                          },
                                        }),
                                        _vm._v("Xuất excel"),
                                      ]
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-left",
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    staticClass: "tdi-batch-dropdown",
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "export_excel_selected",
                                          icon: "el-icon-document-checked",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Theo phiếu thu\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isPackageMode &&
                        _vm.checkPermission(["tuition_v4_import_excel"])
                          ? _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "import_excel",
                                  icon: "el-icon-upload2",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Nhập từ Excel\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        !_vm.isPackageMode &&
                        _vm.checkPermission(["tuition_v4_rename_add_delete"])
                          ? _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "add_batch_revenue",
                                  icon: "el-icon-circle-plus-outline",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Thêm khoản thu\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        !_vm.isPackageMode &&
                        _vm.checkPermission(["tuition_fees_services_action_v4"])
                          ? _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "init_student_invoice",
                                  icon: "el-icon-document-add",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Khởi tạo khoản thu\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown",
                          {
                            staticStyle: { display: "block" },
                            attrs: {
                              placement: "left-start",
                              "popper-options": {
                                modifiers: { flip: { enabled: false } },
                              },
                            },
                            on: { command: _vm.handleBatchCommand },
                          },
                          [
                            _c(
                              "el-dropdown-item",
                              { staticClass: "tdi-nested-menu-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tdi-nested-menu-label" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-s-promotion",
                                      staticStyle: { "margin-right": "6px" },
                                    }),
                                    _vm._v("Gửi học phí"),
                                  ]
                                ),
                                _c("i", { staticClass: "el-icon-arrow-left" }),
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              {
                                staticClass: "tdi-batch-dropdown",
                                attrs: { slot: "dropdown" },
                                slot: "dropdown",
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "send_onekids",
                                      icon: "el-icon-mobile-phone",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Gửi qua Onekids\n                "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "send_sms",
                                      icon: "el-icon-chat-round",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Gửi qua SMS\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-dropdown",
                          {
                            staticStyle: { display: "block" },
                            attrs: {
                              placement: "left-start",
                              "popper-options": {
                                modifiers: { flip: { enabled: false } },
                              },
                            },
                            on: { command: _vm.handleBatchCommand },
                          },
                          [
                            _c(
                              "el-dropdown-item",
                              { staticClass: "tdi-nested-menu-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tdi-nested-menu-label" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-document",
                                      staticStyle: { "margin-right": "6px" },
                                    }),
                                    _vm._v("Xử lý phiếu thu"),
                                  ]
                                ),
                                _c("i", { staticClass: "el-icon-arrow-left" }),
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              {
                                staticClass: "tdi-batch-dropdown",
                                attrs: { slot: "dropdown" },
                                slot: "dropdown",
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "hide",
                                      icon: "el-icon-turn-off",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Bỏ hiển  phiếu thu\n                "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "show",
                                      icon: "el-icon-view",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Hiển thị phiếu thu\n                "
                                    ),
                                  ]
                                ),
                                _vm.canBatchCancel
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "cancel",
                                          icon: "el-icon-circle-close",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Huỷ phiếu thu\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.canBatchRestore
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "restore",
                                          icon: "el-icon-refresh-left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Khôi phục phiếu thu\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.canBatchDelete
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "delete",
                                          icon: "el-icon-delete",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Xoá phiếu thu\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.checkPermission(["electronic-invoice-create-draft"])
                          ? _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "createManyDraft",
                                  icon: "el-icon-document-add",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Tạo nhiều HĐ nháp\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: "registerBank",
                              icon: "el-icon-bank-card",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Chọn TK thanh toán trực tuyến\n            "
                            ),
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: "sync_attendance",
                              icon: "el-icon-bank-card",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Đồng bộ dữ liệu điểm danh\n            "
                            ),
                          ]
                        ),
                        _vm.checkPermission(["tuition_payment_v4"])
                          ? _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "batch_pay",
                                  icon: "el-icon-wallet",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Thanh toán hàng loạt\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: "note",
                              icon: "el-icon-edit-outline",
                            },
                          },
                          [_vm._v("\n              Tạo ghi chú\n            ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._m(1),
      ]),
      _c("unpaid-invoices-dialog", {
        ref: "unpaidInvoicesDialog",
        on: { payment: _vm.handlePayment },
      }),
      _c("student-invoice-history-dialog", {
        ref: "studentInvoiceHistoryDialog",
        on: { payment: _vm.handlePayment, saved: _vm.handleSearch },
      }),
      _c("invoice-action-history-dialog", {
        ref: "invoiceActionHistoryDialog",
      }),
      _c("invoice-payment-history-dialog", {
        ref: "invoicePaymentHistoryDialog",
      }),
      _c("adjust-collected-money-dialog", {
        ref: "adjustCollectedMoneyDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("additional-info-dialog", {
        ref: "additionalInfoDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("edit-invoice-detail-item-dialog", {
        ref: "editInvoiceDetailItemDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("invoice-payment-dialog", {
        ref: "invoicePaymentDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("batch-update-note-dialog", {
        ref: "batchUpdateNoteDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("register-bank-for-order-dialog", {
        ref: "registerBankForOrderDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("send-app-invoice-dialog", {
        ref: "sendAppInvoiceDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("batch-payment-dialog", {
        ref: "batchPaymentDialog",
        on: { saved: _vm.handleSearch },
      }),
      _c("InvoiceCreateManyDialog", {
        attrs: {
          isOpenInvoiceCreateDialog: _vm.isOpenInvoiceCreateManyDialog,
          kidCodes: _vm.selectedKidCodes,
        },
        on: { "dialog-close": _vm.closeInvoiceCreateManyDialog },
      }),
      _c("invoice-excel-import-wizard-dialog", {
        ref: "invoiceExcelImportWizardDialog",
        attrs: {
          "grade-list": _vm.gradeOfSchoolList,
          "class-list": _vm.classList,
          "kid-group-list": _vm.kidGroupList,
          "package-list": _vm.packageList,
        },
        on: {
          "imported-success": _vm.handleImportedSuccess,
          "dialog-close": _vm.handleImportWizardClose,
          "imported-mock-data": _vm.handleImportedMockData,
        },
      }),
      _c("RenameFeeDialog", {
        ref: "renameFeeDialog",
        on: {
          saved: _vm.handleFeeRenamed,
          deleted: _vm.handleFeeDeleted,
          refresh: _vm.handleSearch,
        },
      }),
      _c("AddBatchRevenueDialog", {
        ref: "addBatchRevenueDialog",
        on: { saved: _vm.handleBatchRevenueAdded, refresh: _vm.handleSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "tdi-card-title" }, [
        _vm._v("Quản lý phiếu thu học sinh"),
      ]),
      _c("p", { staticClass: "tdi-card-subtitle" }, [
        _vm._v("Tìm kiếm và theo dõi phiếu thu theo lớp/nhóm/gói."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tdi-notes-section" }, [
      _c("p", { staticClass: "tdi-notes-title" }, [
        _c("i", { staticClass: "el-icon-info" }),
        _vm._v(" Ghi chú về tác vụ xử lý phiếu thu:"),
      ]),
      _c("ul", { staticClass: "tdi-notes-list" }, [
        _c("li", [
          _c("strong", [_vm._v("Huỷ phiếu thu:")]),
          _vm._v(
            " Chỉ áp dụng khi tất cả phiếu thu được chọn đã phát hành, không ở trạng thái "
          ),
          _c("em", [_vm._v("Ẩn")]),
          _vm._v(" và đang ở chế độ "),
          _c("em", [_vm._v("Hiển thị")]),
          _vm._v("."),
        ]),
        _c("li", [
          _c("strong", [_vm._v("Khôi phục phiếu thu:")]),
          _vm._v(
            " Chỉ áp dụng khi tất cả phiếu thu được chọn đang ở trạng thái "
          ),
          _c("em", [_vm._v("Ẩn")]),
          _vm._v("."),
        ]),
        _c("li", [
          _c("strong", [_vm._v("Xoá phiếu thu:")]),
          _vm._v(
            " Chỉ áp dụng khi tất cả phiếu thu được chọn đang ở trạng thái "
          ),
          _c("em", [_vm._v("Ẩn")]),
          _vm._v(". Hành động này không thể hoàn tác."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }